import { AiSparkles } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

interface ILoadingBannerProps {
    onManageLater: () => void;
}

export const LoadingBanner = ({ onManageLater }: ILoadingBannerProps) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="56px"
        padding="8px 16px"
        background={colorsPalettes.bluegrey[200]}
    >
        <Flex
            alignItems="center"
            gap="8px"
        >
            <AiSparkles
                size="sm"
                color={colorsPalettes.carbon[200]}
            />
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("llm.prompts.edit.prompts-table.manage-later.text")}
            </Text>
        </Flex>
        <Button onClick={onManageLater}>{translate("llm.prompts.edit.prompts-table.manage-later.button")}</Button>
    </Flex>
);
